import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/material/styles';
import { StepIconProps } from '@mui/material/StepIcon';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Typography from '@mui/material/Typography';
import {AnimatedCheck} from '../../others/AnimatedCheck';

/**
 * paginationItems
 * @param {Array<Objects>} steps The different steps that will go in the stepper in the following format 
 * [{Component: FormComponent, title: title of step}]
 */

export default function HorizontalLinearStepper({steps}:any) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const stepperInterface = {
    prevStep: () => handleBack(),
    nextStep: () => handleNext(),
    resetStepper: () => handleReset()
  }


  // STYLING FOR STEPPER LINES
  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
         backgroundImage: "linear-gradient( 95deg,#eebbbb 0%,#e38989 50%,#DF6865 100%)"
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage: "linear-gradient( 95deg,#eebbbb 0%,#e38989 50%,#DF6865 100%)"
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));


  // STYLING FOR STEPPER ICONS
  const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    fontSize: "20px",
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      backgroundImage: 'none',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      backgroundColor: "#DF6865",
      border: "2px solid #FFF2F2"
    }),
    ...(ownerState.completed && {
      backgroundImage: 'none',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      backgroundColor: "#DF6865",
      border: "2px solid #FFF2F2"
    }),
  }));
  
  function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {!completed ? (props.icon) :
        (<svg style={{width: "50%"}} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.828822L4.39948 8L0 4.24506L0.830091 3.22497L4.21271 6.11124L8.98833 0L10 0.828822Z" fill="white"/>
        </svg>)}
      </ColorlibStepIconRoot>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((MySteps:any, index:any) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={MySteps.title} {...stepProps}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{MySteps.title}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <div className='w-full flex justify-center items-center'>
          <AnimatedCheck/>
        </div>  
      ) : (
        <>
          {steps[activeStep].Component(stepperInterface)}
        </>
      )}
    </Box>
  );
}
